import { combineReducers } from "@reduxjs/toolkit";
import areaSlice from "./slices/areaSlice";
import assortmentTreeSlice from "./slices/assortmentTreeSlice";
import baseUnitMeasureSlice from "./slices/baseUnitMeasureSlice";
import billLadingSlice from "./slices/billLadingSlice";
import brandSlice from "./slices/brandSlice";
import categorySlice from "./slices/categorySlice";
import divisionSlice from "./slices/divisionSlice";
import groupSlice from "./slices/groupSlice";
import importCostSlice from "./slices/importCostSlice";
import inventoryGroupSlice from "./slices/inventoryGroupSlice";
import ivaPostingGroupSlice from "./slices/ivaPostingGroupSlice";
import ivaSlice from "./slices/ivaSlice";
import ivaXPostingGroupSlice from "./slices/ivaXPostingGroupSlice";
import levelSlice from "./slices/levelSlice";
import productDetailSlice from "./slices/productDetailSlice";
import productMinMaxAlertSlice from "./slices/productMinMaxAlertSlice";
import productModifier from "./slices/productModifierSlice";
import productModifierGroupSlice from "./slices/productModifierGroupSlice";
import productPriceXCustomerSlice from "./slices/productPriceXCustomerSlice";
import productPriceXPriceGroupSlice from "./slices/productPriceXPriceGroupSlice";
import productSlice from "./slices/productSlice";
import productTypeSlice from "./slices/productTypeSlice";
import productVariantSlice from "./slices/productVariantSlice";
import productXBarcodeSlice from "./slices/productXBarcodeSlice";
import productXSpecialGroupSlice from "./slices/productXSpecialGroupSlice";
import productXProductModifierSlice from "./slices/productXProductModifierSlice";
import productXVariantSlice from "./slices/productXVariantSlice";
import purchaseReceiptSlice from "./slices/purchaseReceiptSlice";
import purchaseRequestDetailSlice from "./slices/purchaseRequestDetailSlice";
import purchaseRequestSlice from "./slices/purchaseRequestSlice";
import quotationSlice from "./slices/quotationSlice";
import requisitionSlice from "./slices/requisitionSlice";
import specialGroupSlice from "./slices/specialGroupSlice";
import tableSlice from "./slices/tableSlice";
import uploadAdjustmentInventorySlice from "./slices/uploadAdjustmentInventorySlice";
import uploadInventorySlice from "./slices/uploadInventorySlice";
import vendorSlice from "./slices/vendorSlice";
import warehouseTransferSlice from "./slices/warehouseTransferSlice";
import warrantyFormatSlice from "./slices/warrantyFormatSlice";
import warrantyModelSlice from "./slices/warrantyModelSlice";
import warrantySlice from "./slices/warrantySlice";
import warrantyTreeSlice from "./slices/warrantyTreeSlice";

export default combineReducers({
  area:areaSlice,
  assortmentTree: assortmentTreeSlice,
  baseUnitMeasure: baseUnitMeasureSlice,
  billLading: billLadingSlice,
  brand: brandSlice,
  category: categorySlice,
  division: divisionSlice,
  group: groupSlice,
  importCost: importCostSlice,
  inventoryGroup: inventoryGroupSlice,
  iva: ivaSlice,
  ivaPostingGroup: ivaPostingGroupSlice,
  ivaXPostingGroup: ivaXPostingGroupSlice,
  level: levelSlice,
  modifier: productModifier,
  modifierGroup: productModifierGroupSlice,
  product: productSlice,
  productDetail: productDetailSlice,
  productMinMaxAlert: productMinMaxAlertSlice,
  productPriceXCustomer: productPriceXCustomerSlice,
  productPriceXPriceGroup: productPriceXPriceGroupSlice,
  productType: productTypeSlice,
  productVariant: productVariantSlice,
  productXBarcode: productXBarcodeSlice,
  productXSpecialGroup: productXSpecialGroupSlice,
  productXProductModifier: productXProductModifierSlice,
  productXVariant: productXVariantSlice,
  purchaseReceipt: purchaseReceiptSlice,
  purchaseRequest: purchaseRequestSlice,
  purchaseRequestDetail: purchaseRequestDetailSlice,
  quotation: quotationSlice,
  requisition: requisitionSlice,
  specialGroup: specialGroupSlice,
  table:tableSlice,
  uploadAdjustmentInventory: uploadAdjustmentInventorySlice,
  uploadInventory: uploadInventorySlice,
  vendor: vendorSlice,
  warehouseTransfer: warehouseTransferSlice,
  warranty: warrantySlice,
  warrantyFormat: warrantyFormatSlice,
  warrantyModel: warrantyModelSlice,
  warrantyTree: warrantyTreeSlice,
});
